import classNames from 'classnames'
import styles from './h1.module.css'

type Props = {
  children: React.ReactNode,
  alignment?: 'flex-start' | 'center',
  level?: number,
  className?: string,
  suppressMargins?: boolean,
}

const getElementForLevel = {
  1: (children: React.ReactNode, className: string) =>
    <h1 className={className}>{ children }</h1>,
  2: (children: React.ReactNode, className: string) =>
    <h2 className={className}>{ children }</h2>,
  3: (children: React.ReactNode, className: string) =>
    <h3 className={className}>{ children }</h3>,
  4: (children: React.ReactNode, className: string) =>
    <h4 className={className}>{ children }</h4>,
  5: (children: React.ReactNode, className: string) =>
    <h5 className={className}>{ children }</h5>,
  6: (children: React.ReactNode, className: string) =>
    <h6 className={className}>{ children }</h6>,
} as { [key: number]: Function }

const Heading = ({ children, level = 1, className = '', suppressMargins = false, alignment = 'flex-start' }: Props) => {
  const elementClassName = classNames(
    styles[`heading${level}`], styles[alignment],
    {
      [styles.suppressMargins]: suppressMargins,
    },
    className,
  )
  return getElementForLevel[level](children, elementClassName)
}

export default Heading
